import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSession } from '../../services/core/auth-session/auth-session';

export const guestGuard: CanActivateFn = () => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return true;
  }

  const authSession = inject(AuthSession);
  if (!authSession.isAuthenticated()) {
    return true;
  }

  const router = inject(Router);
  return router.createUrlTree([authSession.isAdministrator() ? '/working/dashboard' : '/portal/home']);
};
